export default {"src":"/_next/static/media/fallback-image.aaf028f4.svg","height":196,"width":324,"blurWidth":0,"blurHeight":0};